'use strict'

import App from '@/App.vue'
import bootstrap from '@/bootstrap.js'

(async function() {
  (await bootstrap(App)).$mount('#app')
})()
